import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';

// Import pages
import Home from './pages/Home';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AcceptInvite from './pages/AcceptInvite';
import Messages from './pages/Messages';       // was Dashboard.js
import Respond from './pages/Respond';          // was Messages.js
import MessageDetail from './pages/MessageDetail';
import Overview from './pages/Overview';
import LandingPage from './pages/LandingPage';
import MeetingNotes from './pages/MeetingNotes';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import TermsOfService from './pages/legal/TermsOfService';
import DataDeletion from './pages/legal/DataDeletion';
import About from './pages/legal/About';

function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/contact" element={<Home />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/data-deletion" element={<DataDeletion />} />
      <Route path="/about" element={<About />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/accept-invite" element={<AcceptInvite />} />

      {/* Protected Routes - Admin Only */}
      <Route path="/messages" element={
        <ProtectedRoute><Messages /></ProtectedRoute>
      } />
      <Route path="/meeting-notes" element={
        <ProtectedRoute><MeetingNotes /></ProtectedRoute>
      } />
      <Route path="/respond" element={
        <ProtectedRoute><Respond /></ProtectedRoute>
      } />
      <Route path="/respond/:id" element={
        <ProtectedRoute><MessageDetail /></ProtectedRoute>
      } />
      <Route path="/overview" element={
        <ProtectedRoute><Overview /></ProtectedRoute>
      } />

      {/* Legacy redirect — in case any old /dashboard links exist */}
      <Route path="/dashboard" element={<Navigate to="/messages" replace />} />

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default AppRoutes;